export default class ChartStyle {
  static TEXT_FONT_FAMILY = '宋体'

  static NUMBER_FONT_FAMILY = 'Times New Roman'

  static BAR_MAX_WIDTH = 30

  static AXIS_LINE_COLOR = 'rgba(255, 255, 255, 0.3)'

  static AXIS_SPLIT_LINE_COLOR = 'rgba(255, 255, 255, 0.3)'

  static TEXT_COLOR = '#FFFFFF'

  static INACTIVE_COLOR = '#bbbbbb'

  static LEGEND_PAGE_TEXT_COLOR = '#FFFFFF'

  static LEGEND_PAGE_ICON_COLOR = '#FFFFFF'

  static LEGEND_PAGE_ICON_INACTIVE_COLOR = '#bbbbbb'
}



// WEBPACK FOOTER //
// ./src/views/07Env/02History/ChartStyle.js